import { populatePlaceholderText } from '@/presentlevels/api_v1.js'
import type { DefaultStatement, StatementResource, StatementStandard } from '@/presentlevels/no-ai/skill_statement_types'

// Statements fetched for one category also carry its name.
export type BrowseStatement = DefaultStatement & { skill_name?: string }

// Browsing has no student, so the statement names a placeholder the teacher fills in.
const STUDENT_NAME_PLACEHOLDER = '(Name)'

function todayAsMonthDayYear(today: Date): string {
  return `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`
}

// The statement is written as though the student were at the chosen level.
export function statementTextAtLevel(statement: DefaultStatement, level: string, today: Date = new Date()): string {
  return populatePlaceholderText(statement.statement_text, {
    studentName: STUDENT_NAME_PLACEHOLDER,
    studentGrade: level,
    dateStr: todayAsMonthDayYear(today)
  })
}

function isUsableResource(resource: StatementResource): boolean {
  return Boolean(resource.uuid) && !resource.error
}

export function resourcesByUuid(statement: DefaultStatement): Record<string, StatementResource> {
  const usableResources = (statement.resource_docs ?? []).filter(isUsableResource)
  return Object.fromEntries(usableResources.map((resource) => [resource.uuid, resource]))
}

function isShownStandard(standard: StatementStandard, visibleStandardSets: string[]): boolean {
  const hasReference = Boolean(standard.standard_long_ref?.trim())
  return hasReference && visibleStandardSets.includes(standard.standard_set_code)
}

export function standardsBySetCode(statement: DefaultStatement, visibleStandardSets: string[]): Record<string, StatementStandard[]> {
  const grouped: Record<string, StatementStandard[]> = {}
  const shownStandards = (statement.standard_docs ?? []).filter((standard) => isShownStandard(standard, visibleStandardSets))
  for (const standard of shownStandards) {
    grouped[standard.standard_set_code] ??= []
    grouped[standard.standard_set_code].push(standard)
  }
  return grouped
}
